module.exports = " <div class=UsersWidget> <ul class=list> <li v-for=\"user of users\" @click=toggle(user.id) :class=\"{ selected: selectedUsers.indexOf(user.id) > -1 }\"> <span>{{ user.firstname }} {{ user.lastname }}</span> <span class=checkbox :style=\"{ backgroundColor: user.color }\"></span> </li> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/widgets/Users.vue
// module id = 527
// module chunks = 1